import type { SVGAttributes } from "react"

export default function AppLogoIcon(props: SVGAttributes<SVGElement>) {
  return (
    <svg
      height="24"
      viewBox="0 0 24 24"
      width="24"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      {/* Beetle/Scarab icon */}
      <path
        fill="currentColor"
        d="M12 2C9.5 2 7.5 4 7.5 6.5c0 .5.1 1 .2 1.5H5.5C5.2 8 5 8.2 5 8.5S5.2 9 5.5 9h2.6c.6 1.3 1.6 2.3 2.9 2.8V13H8c-.3 0-.5.2-.5.5S7.7 14 8 14h3v2.5c0 .3-.2.5-.5.5H6c-.3 0-.5.2-.5.5S5.7 18 6 18h4.5c.8 0 1.5-.7 1.5-1.5V14h1v2.5c0 .8.7 1.5 1.5 1.5H18c.3 0 .5-.2.5-.5S18.3 17 18 17h-2.5c-.3 0-.5-.2-.5-.5V14h3c.3 0 .5-.2.5-.5s-.2-.5-.5-.5h-2.5v-1.2c1.3-.5 2.3-1.5 2.9-2.8h2.6c.3 0 .5-.2.5-.5S21.3 8 21 8h-2.2c.1-.5.2-1 .2-1.5C19 4 17 2 14.5 2 13.8 2 13 2.2 12 3c-1-.8-1.8-1-2.5-1zm2.5 1c1.9 0 3.5 1.6 3.5 3.5S16.4 10 14.5 10 11 8.4 11 6.5 12.6 3 14.5 3z"
      />
    </svg>
  )
}
